import * as React from 'react';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-92398359-3');

class Page extends React.Component {
  constructor(props) {
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
    this.ReactGA = ReactGA;
  }
}

export default Page;
